import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import React, {Fragment} from 'react';
import {useTranslation} from 'react-i18next';

interface Props {
  step: number;
  total: number;
}

export const Stepper = ({step, total}: Props): React.ReactElement => {
  const {t} = useTranslation('components', {keyPrefix: 'store.stepper'});
  const {accentColor, hasDarkBg} = useThemeContext();

  return step === 0 ? (
    <Fragment />
  ) : (
    <nav className="flex h-14 items-center justify-start" aria-label="Progress">
      <p className={classNames('text-sm font-medium', hasDarkBg ? 'text-white' : 'text-gray-900')}>
        {t('step', {step, total})}
      </p>
      <ol role="list" className="ml-8 flex items-center space-x-5">
        {[...Array(step - 1).keys()].map(index => (
          <li
            key={index}
            className="block h-2.5 w-2.5 rounded-full"
            style={{backgroundColor: accentColor}}
          />
        ))}

        <span className="relative flex items-center justify-center" aria-current="step">
          <span className="absolute flex h-5 w-5 p-px" aria-hidden="true">
            <li
              className="h-full w-full rounded-full opacity-20"
              style={{backgroundColor: accentColor}}
            />
          </span>

          <li
            className="relative block h-2.5 w-2.5 rounded-full"
            style={{backgroundColor: accentColor}}
          />
        </span>

        {[...Array(total - step).keys()].map(index => (
          <li
            key={index}
            className={classNames(
              'block h-2.5 w-2.5 rounded-full',
              hasDarkBg ? 'bg-white/20' : 'bg-black/20'
            )}
          />
        ))}
      </ol>
    </nav>
  );
};
Stepper.displayName = 'Stepper';
